/** MIME + text/plain fallback for HTML5 session drag-and-drop (Chromium/Electron). */

export const SESSION_MIME = 'application/apolo-session-id';
const SESSION_PLAIN_PREFIX = 'apolo-session:';

export function setSessionDragData(dataTransfer, sessionId) {
  if (!dataTransfer || !sessionId) return;
  try {
    dataTransfer.setData(SESSION_MIME, sessionId);
  } catch {
    /* some environments reject custom MIME on setData */
  }
  dataTransfer.setData('text/plain', `${SESSION_PLAIN_PREFIX}${sessionId}`);
  dataTransfer.effectAllowed = 'move';
}

export function readSessionIdFromDataTransfer(dataTransfer) {
  if (!dataTransfer) return null;
  let id = '';
  try {
    id = dataTransfer.getData(SESSION_MIME);
  } catch {
    id = '';
  }
  if (id) return id;

  const plain = dataTransfer.getData('text/plain') || '';
  if (plain.startsWith(SESSION_PLAIN_PREFIX)) {
    return plain.slice(SESSION_PLAIN_PREFIX.length);
  }
  return null;
}

export function isSessionDragEvent(event) {
  const types = event?.dataTransfer?.types;
  if (!types) return false;
  const has = (key) => {
    if (typeof types.includes === 'function') return types.includes(key);
    if (typeof types.contains === 'function') return types.contains(key);
    return Array.from(types).includes(key);
  };
  if (has(SESSION_MIME)) return true;
  return has('text/plain');
}
